<template lang="html">
  <div>
    <Layout currentMenu="Account" subMenu="City Page Management" :fullScreenLoading="saving">
      <LoadingSection :loading="loading" title="City Page Management" :autoPadding="false">
        <template v-slot:content>
          <SymbiumButton
            text="New City Page"
            :onClick="openNewPostModal"
            :isSmall="true"
          />
          <draggable
            v-model="articles"
            draggable=".draggable-section"
            @end="updateArticlesOrder"
          >
            <div class="draggable-section" v-for="article in articles" :key="article.id">
              <div class="gap-3x" />
              <div class="line-break" />
              <div class="gap-3x" />
              <div>
                <div class="edit-link cursor-pointer" @click="() => openEditPostModal(article)">
                  {{article.subject}}
                </div>
              </div>
            </div>
          </draggable>
        </template>
      </LoadingSection>
    </Layout>
    <EditCityPageModal @updated="reload" @destroy="openDestroyConfirm" />
    <ConfirmModal />
  </div>
</template>

<script>
import Draggable from 'vuedraggable'

import ConfirmModal from 'src/components/common/modals/ConfirmModal'
import Layout from 'src/components/dashboard/shares/Layout.vue'
import LoadingSection from 'src/components/dashboard/shares/LoadingSection.vue'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

import EditCityPageModal from './modals/EditCityPageModal.vue'
import ArticleSortable from './mixins/ArticleSortable.js'

export default {
  components: {
    LoadingSection, Layout, ConfirmModal,
    SymbiumButton, EditCityPageModal, Draggable
  },
  mixins: [ArticleSortable],
  data() {
    return {
      articleType: "CityPage",
    }
  },
  methods: {
    openNewPostModal() {
      this.$modal.show('edit-city-page-modal', { article: { data: {}, type: this.articleType } })
    },
    openEditPostModal(article) {
      this.$modal.show('edit-city-page-modal', { article })
    },
  },
}
</script>
